
import {
  Component, Mixins,
} from 'vue-property-decorator';
import UserGroups from '@/components/UserGroups.vue';
import EditLeadUsersDialog from '@/components/EditLeadUsersDialog.vue';
import {
  AssignmentAssignee, AssignmentType, Lead, PermissionCode, User,
} from '@/types';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import { getAssignmentLabel } from '@/helpers';

@Component({
  components: {
    UserGroups,
    EditLeadUsersDialog,
  },
})
export default class LeadUsers extends Mixins(UtilsMixin) {
  editDialog = false

  mounted() {
    if (this.$store.getters.getAssignmentTypes.length === 0) {
      this.$store.dispatch('fetchAssignmentTypes');
    }
  }

  get user(): User | null {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get lead(): Lead | null{
    return this.$store.getters.currentLead;
  }

  get requester(): User | null {
    return this.lead?.requester ?? null;
  }

  get owners(): User[] | null {
    return this.lead?.owners ?? null;
  }

  get isRequester() {
    return this.user?.id !== null && this.user?.id === this.lead?.requesterId;
  }

  get isEditable() {
    return (this.isRequester && this.lead?.status === 'new')
      || this.hasPermission('leads.modify_owners')
      || this.hasPermission('leads.modify_requester');
  }

  get assignmentTypes(): AssignmentType[] {
    return this.$store.getters.getAssignmentTypes;
  }

  get ownerAssignmentsMap(): Record<number, { type: AssignmentType; label: string; assignedDate: AssignmentAssignee['assignedDate'] }[]> {
    const map: Record<number, { type: AssignmentType; label: string; assignedDate: AssignmentAssignee['assignedDate'] }[]> = {};
    if (!this.lead) return map;

    const childType = this.lead.type;
    const customValues = Array.isArray(this.lead.CustomValues) ? this.lead.CustomValues : [];

    // Generico su TUTTI i tipi incarico (practice, project, enea, dogane,
    // installer, ...): per ciascuno legge la CV `${type.id}Assignees` iniettata
    // da getLead. Iterando la lista dallo store evita disallineamenti quando si
    // aggiungono nuovi tipi. CV mancanti (es. tipi non applicabili alla figlia)
    // vengono semplicemente saltate.
    this.assignmentTypes.forEach((typeConfig) => {
      const cv = customValues.find((c) => c.name === `${typeConfig.id}Assignees`);
      if (!cv?.value) return;

      const resolvedLabel = getAssignmentLabel(typeConfig, childType);

      this.parseAssignees(cv.value)
        .filter((a) => a.status === 'done' && a.assigneeId !== null)
        .forEach((a) => {
          const id = a.assigneeId as number;
          if (!map[id]) map[id] = [];
          map[id].push({ type: typeConfig, label: resolvedLabel, assignedDate: a.assignedDate });
        });
    });

    return map;
  }

  parseAssignees(raw: string | null | undefined): AssignmentAssignee[] {
    if (!raw) return [];
    try { return JSON.parse(raw); } catch { return []; }
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onEdit() {
    this.editDialog = true;
  }
}
